{
  "newFeature": "Um alternador de aplicativos simplificado agora inclui apenas aplicativos ativados para você em uma única lista.",
  "newLayout": "Novo layout",
  "ok": "Ok"
}
